package com.vizio.redwolf.auth.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class AccountProducts(
    val product: String? = null,
    val productType: String? = null,
    val model: String? = null,
    val serialNumber: String? = null,
    val dateRegistered: String? = null,
)

@JsExport
data class AccountRegisteredProductsResponse(val products: List<AccountProducts>)

@Serializable
data class AccountRegisterProductInfo(
    val firstName: String,
    val lastName: String,
    val streetAddress: String,
    val additionalAddress: String,
    val city: String,
    val state: String,
    val postalCode: String,
    val phone: String,
    val email: String,
    @SerialName("emailOptin") val emailOptIn: Boolean,
    val serialNumbers: List<String> = emptyList()
)

@Serializable
data class UpdateAccountRegisteredProductsInfo(
    val serialNumbers: List<String>
)